import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/webhooksCodeSnippet.scss';
import { setPlaceholders, useLocalize } from '../../../hooks/useLocalize';
import { Collapsible } from '../../../elements/Collapsible/Collapsible';
import { CodePreview } from '../../../elements/CodePreview/CodePreview';
import { Typography } from '../../../elements/Typography/Typography';
import { TypographyLevel } from '../../../elements/Typography/TypographyLevel';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { TabPanel, TabItem } from '../../../elements/TabPanel/TabPanel';
export const WebhooksCodeSnippet = ({ webhookUrl = '', onOpened }) => {
    const isExistsUrl = isValidString(webhookUrl);
    const [codeSnippetTitle, codeSnippetTip, codeSnippetWebhookURL, placeOrderTabTitle, modifyOrderTabTitle, cancelOrderTabTitle, copyToClipboardTooltip] = useLocalize('screen.Webhooks.CodeSnippet.Title', 'screen.Webhooks.CodeSnippet.Tip', isExistsUrl
        ? ['screen.Webhooks.CodeSnippet.WebhookURL.Exists', [webhookUrl]]
        : 'screen.Webhooks.CodeSnippet.WebhookURL.NotExists', 'screen.Webhooks.CodeSnippet.PlaceOrderTabTitle', 'screen.Webhooks.CodeSnippet.ModifyOrderTabTitle', 'screen.Webhooks.CodeSnippet.CancelOrderTabTitle', 'general.CopyToClipboard');
    const renderCodeSnippet = (code) => {
        return (_jsx("div", { className: "webhooks-code-snippet-content-tab-panel", children: _jsx(CodePreview, { code: code, copyButtonTooltip: copyToClipboardTooltip, onCopyButtonClick: (value) => {
                    void navigator.clipboard.writeText(value);
                } }) }));
    };
    const placeOrderObject = {
        action: 'place',
        accountName: 'account1',
        symbol: 'INSTRUMENT1',
        type: 'limit',
        price: 100,
        qty: 50,
        side: 'buy',
        validity: 'DAY'
    };
    const modifyOrderObject = {
        action: 'modify',
        accountName: 'account1',
        orderId: 1,
        price: 80
    };
    const cancelOrderObject = {
        action: 'cancel',
        accountName: 'account1',
        orderId: 1
    };
    return (_jsx(Collapsible, { title: codeSnippetTitle, className: "webhooks-code-snippet", onOpened: onOpened, children: _jsxs(Stack, { className: "webhooks-code-snippet-content", direction: "column", children: [_jsx(Typography, { className: "webhooks-code-snippet-content-tip", level: TypographyLevel.BodyMd, children: setPlaceholders(codeSnippetTip, [codeSnippetWebhookURL]) }), _jsxs(TabPanel, { headerClassName: "webhooks-code-snippet-content-tab-panel-header", mode: "stretch", children: [_jsx(TabItem, { title: placeOrderTabTitle, children: renderCodeSnippet(placeOrderObject) }), _jsx(TabItem, { title: modifyOrderTabTitle, children: renderCodeSnippet(modifyOrderObject) }), _jsx(TabItem, { title: cancelOrderTabTitle, children: renderCodeSnippet(cancelOrderObject) })] })] }) }));
};
